export const Template_Src: Record<
  string,
  {
    aspectRatio: number;
    url?: string;
  }
> = {
  'ethtrend-vote.xyz': {
    aspectRatio: 1.95,
  },
};
